import React from 'react';

type ReportFilterSelectProps = {
  name: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
};

export default function ReportFilterSelect({
  name,
  options,
  onChange,
}: ReportFilterSelectProps) {
  return (
    <select
      className='form-select'
      aria-label={name}
      name={name}
      defaultValue={undefined}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value=''>Selecione</option>
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
